export const currentYear = new Date().getFullYear()
export const fromMonth = new Date(currentYear - 10, 0)
export const toMonth = new Date(currentYear + 10, 11)
